import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { pickLocalized } from "../../i18n/pickLocalized";

/**
 * `planName(planId)`: a plan's display name in `lang`, from the public plan list
 * (`GET /saas/plans`, readable by every operator; `/super-admin/plans` is super admin only).
 * That list holds the ACTIVE plans: a retired plan, a plan the list does not name, or a failed
 * read leaves the stored id on screen, which is still the truth, only less friendly.
 */
export function usePlanNames(lang) {
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    let live = true;
    api.get("/saas/plans")
      .then((r) => { if (live && Array.isArray(r.data)) setPlans(r.data); })
      .catch(() => {}); // the ids stay on screen; nothing else depends on this read
    return () => { live = false; };
  }, []);
  return useCallback((planId) => {
    const plan = plans.find((p) => p?.plan_id === planId);
    return (plan && pickLocalized(plan, "name", lang)) || planId;
  }, [plans, lang]);
}
